import { vehicleApi } from "@api";
import { getDateListMonth, theme } from "@utils";
import { useEffect, useState } from "react";
import { holidayApi } from "src/Api/holiday";
import { StyledVehicleBorrowingCalendar } from "./styles";
import { TitleMenuComponent } from "../TitleMenuComponent";
import { menuTitleEnums } from "@enums";
import { BorrowingCalendarContent } from "./BorrowingCalendarContent";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

interface LocationState {
  searchWord?: any;
}

export const VehicleBorrowingCalendar = () => {
  const location = useLocation<LocationState>();
  const [holidays, setHolidays] = useState<string[]>([]);
  const [month, setMonth] = useState<string>(new Date().toISOString().slice(0, 7));
  const [vehicles, setVehicles] = useState<any[]>([]);
  const searchWord = location.state?.searchWord || "";

  useEffect(() => {
    fetchListBorrowing();
    fetchHoliday();
  }, [month]);

  const fetchHoliday = async () => {
    try {
      const res = await holidayApi.getMonthHolidays({
        year: parseInt(month.slice(0, 4)),
        month: parseInt(month.slice(5, 7)),
        page_key: "vehicle"
      });
      const holidayDates = res.data.data.date_holiday.map((d) => d.date);
      setHolidays(holidayDates);

    } catch (error) {
      console.error("休日情報取得失敗", error);
    }
  };

  // const fullState = useSelector((state) => state);
  // console.log("全state", fullState);

  //車両リストの検索結果をReduxから取得
  const filterResult = useSelector((state: { vehicle: { dataResult: any } }) => state.vehicle.dataResult);
  // console.log("車両リストの検索結果", filterResult);

  const fetchListBorrowing = async () => {
    try {

      let data: { year: number; month: number; category_id?: number; subCategory_id?: number, searchWord?: string } = {
        year: parseInt(month.slice(0, 4)),
        month: parseInt(month.slice(5, 7)),
      };

      //車両リストで検索結果がある場合、カテゴリーIDとサブカテゴリーIDを追加
      if (filterResult?.categoryId) {
        data.category_id = filterResult.categoryId;
        data.subCategory_id = filterResult.subCategoryId;
      }

      //文字検索していた場合は検索ワードを追加
      if (searchWord?.trim()) {
        data.searchWord = searchWord;
      }

      const res = await vehicleApi.getVehicleBorrowingList(data);

      // console.log("車両リスト", res.data.data);
      setVehicles(res.data.vehicles);

    } catch (error) {
      console.error("車両リスト取得失敗", error);
    }
  };

  const handleMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    setMonth(selectedDate);
  };

  const dateListArray = getDateListMonth(month);
  console.log("vehicles", vehicles);

  return (
    <StyledVehicleBorrowingCalendar>
      <div>
        <div className="topTitle">
          <TitleMenuComponent text={menuTitleEnums.TITLE_VEHICLES} />
        </div>
        <div className="wrapperInput">
          <div className="datePicker">
            <div className="label" >日付</div>
            <div className="wrapperDatePicker">
              <input
                type="month"
                value={month}
                onChange={handleMonthChange}
                style={{
                  padding: "1rem",
                  borderRadius: "24px",
                  border: `1px solid ${theme.colors.gray03}`,
                  fontSize: "1.5rem",
                  fontFamily: "NotoSansJP-500",
                  color: `${theme.colors.black01}`,
                  backgroundColor: `${theme.colors.white02}`,
                }}
              />
            </div>
          </div>
        </div>

        <BorrowingCalendarContent data={vehicles} itemType="vehicles" dateList={dateListArray} holidays={holidays} />

      </div>
    </StyledVehicleBorrowingCalendar>
  );
};
